import { render, staticRenderFns } from "./x-button.vue?vue&type=template&id=5b27f593&"
import script from "./x-button.vue?vue&type=script&lang=ts&"
export * from "./x-button.vue?vue&type=script&lang=ts&"
import style0 from "./x-button.vue?vue&type=style&index=0&id=5b27f593&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports